import React from 'react';

export const LoadingIndicator = ({width, height}) => {
  const style = {
    width,
    height
  }

  return (
    <span className="loader" style={style}></span>
  )
};

